module.exports = __webpack_public_path__ + "static/media/information.239b0e34.svg";